export default __webpack_public_path__ + "static/ui-tasks-dade70b5194cc1e12023ed4ebea28dc2.png";